export class InboxreaderLabel {
	ID:number = 0;
	Name:string = "";
	Color:string = "#3788d8";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Name = data.Name;
		if (data.Color) this.Color = data.Color;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Name: this.Name,
			Color: this.Color
		};
	}
}
